<template>
  <div />
</template>

<script>
/** shortcut utils */
import { subscribeToKeyup, subscribeToKeydown } from "@/utils/shortcuts.js";
import { mapGetters } from "vuex";

// @group Timeline
// Timeline shortcuts binding component
export default {
  props: {
    /** visible timeline length in seconds */
    fullLength: {
      type: Number,
      default: 24 * 36
    }
  },
  data() {
    return {
      /** crop continuos move stopping ID's */
      leftCropStoppingId: null,
      rightCropStoppingId: null,
      /** basic max step */
      cropMovingStep: 24 * 36,
      cropStepMult: 1,
      /** crop changing interval in ms */
      cropMovingInterval: 50
    };
  },
  computed: {
    ...mapGetters("timeline", ["isSliderLeftVisible", "isSliderRightVisible"]),
    // @vuese
    // Crop step size based on current stream length and zoom
    relativeCropStep() {
      let stepBase = (this.fullLength / 100) * this.cropStepMult;
      if (isNaN(stepBase)) {
        stepBase = this.cropMovingStep;
      }

      return stepBase;
    }
  },
  watch: {
    isSliderLeftVisible() {
      if (!this.isSliderLeftVisible && this.leftCropStoppingId) {
        this.stopMovingLeftCrop();
      }
    },
    isSliderRightVisible() {
      if (!this.isSliderRightVisible && this.rightCropStoppingId) {
        this.stopMovingRightCrop();
      }
    }
  },
  mounted() {
    subscribeToKeydown("KeyC", this.startMovingLeftCropToLeft);
    subscribeToKeyup("KeyC", this.stopMovingLeftCrop);

    subscribeToKeydown("KeyV", this.startMovingLeftCropToRight);
    subscribeToKeyup("KeyV", this.stopMovingLeftCrop);

    subscribeToKeydown("Comma", this.startMovingRightCropToLeft);
    subscribeToKeyup("Comma", this.stopMovingRightCrop);

    subscribeToKeydown("Period", this.startMovingRightCropToRight);
    subscribeToKeyup("Period", this.stopMovingRightCrop);
  },
  methods: {
    // @vuese
    // Move left crop border
    // @arg value - time step in seconds
    moveLeftCrop(value) {
      this.$emit("moveLeftCrop", value);
    },
    // @vuese
    // Move right crop border
    // @arg value - time step in seconds
    moveRightCrop(value) {
      this.$emit("moveRightCrop", value);
    },
    /** crop continuos moving */
    // @vuese
    // Start move left crop to left
    startMovingLeftCropToLeft() {
      if (!this.isSliderLeftVisible) return;
      this.startMovingLeftCrop(false);
    },
    // @vuese
    // Start move left crop to right
    startMovingLeftCropToRight() {
      if (!this.isSliderLeftVisible) return;
      this.startMovingLeftCrop(true);
    },
    // @vuese
    // Start move right crop to left
    startMovingRightCropToLeft() {
      if (!this.isSliderRightVisible) return;
      this.startMovingRightCrop(false);
    },
    // @vuese
    // Start move right crop to right
    startMovingRightCropToRight() {
      if (!this.isSliderRightVisible) return;
      this.startMovingRightCrop(true);
    },
    // @vuese
    // Start move left crop by hotkey
    // @arg to increase crop time
    startMovingLeftCrop(toRight) {
      const step = (toRight ? 1 : -1) * this.relativeCropStep;

      if (this.leftCropStoppingId) {
        this.stopMovingLeftCrop();
      }

      this.leftCropStoppingId = setInterval(
        () => this.moveLeftCrop(step),
        this.cropMovingInterval
      );
      // this.$nextTick(this.moveLeftCrop.bind(this, step));

      this.$emit("startLeftCropMoving");
    },
    // @vuese
    // Start move right crop by hotkey
    // @arg to increase crop time
    startMovingRightCrop(toRight) {
      const step = (toRight ? 1 : -1) * this.relativeCropStep;

      if (this.rightCropStoppingId) {
        this.stopMovingRightCrop();
      }

      this.rightCropStoppingId = setInterval(
        () => this.moveRightCrop(step),
        this.cropMovingInterval
      );
      // this.$nextTick(this.moveRightCrop.bind(this, step));

      this.$emit("startRightCropMoving");
    },
    // @vuese
    // Stop moving of left crop to left
    stopMovingLeftCrop() {
      clearInterval(this.leftCropStoppingId);
      this.leftCropStoppingId = null;
      this.$emit("stopLeftCropMoving");
    },
    // @vuese
    // Stop moving of left crop to left
    stopMovingRightCrop() {
      clearInterval(this.rightCropStoppingId);
      this.rightCropStoppingId = null;
      this.$emit("stopRightCropMoving");
    }
  }
};
</script>
